import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Interface:
interface UserState {
  accessToken: string;
  userInfo: {};
}

// init State:
const initialState: UserState = {
  accessToken: '',
  userInfo: {},
};

// Create State:
const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setAccessToken: (state, action: PayloadAction<string>) => {
      state.accessToken = action.payload;
    },
    setUserInfo: (state, action: PayloadAction<any>) => {
      state.userInfo = action.payload;
    },
  },
});

// Configuration for redux-persist
const userPersistConfig = {
  key: 'user',
  storage,
  // Persist required fields
  whitelist: ['accessToken', 'userInfo'],
};

// Actions
export const { setAccessToken, setUserInfo } = userSlice.actions;

const persistedUserReducer = persistReducer(userPersistConfig, userSlice.reducer);

export default persistedUserReducer;
